// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import SpeakerSvg from '@rsuite/icon-font/lib/application/Speaker';
var Speaker = createSvgIcon({
  as: SpeakerSvg,
  ariaLabel: 'speaker',
  category: 'application',
  displayName: 'Speaker'
});
export default Speaker;